import * as h2Api from '../../h2Api'

export const SET_SEARCH_TERM = 'EARLY_SET_SEARCH_TERM'
export const PERFORM_SEARCH = 'EARLY_PERFORM_SEARCH'
export const SEARCH_LOADING = 'EARLY_SEARCH_LOADING'
export const SET_SEARCH_PAGE = 'SET_SEARCH_PAGE'

export const setSearchTerm = t => dispatch => {
  return Promise.resolve(dispatch({ type: SET_SEARCH_TERM, searchTerm: t }))
}

export const setSearchLoading = v => dispatch => {
  return Promise.resolve(dispatch({ type: SEARCH_LOADING, value: v }))
}

export const setPrevPage = () => (dispatch, getState) => {
  let p = getState().early.search.page

  p = Math.max(0, p - 1)

  return dispatch(setPage(p))
}

export const setNextPage = () => (dispatch, getState) => {
  let p = getState().early.search.page

  p = Math.max(0, p + 1)

  return dispatch(setPage(p))
}

export const setPage = v => dispatch => {
  return Promise.resolve(dispatch({ type: SET_SEARCH_PAGE, page: v }))
}

export const performSearch = () => (dispatch, getState) => {
  dispatch(setSearchLoading(true))
  const st = getState().early.search

  return dispatch(
    h2Api.get(`/search/early/${encodeURI(st.term)}?numResults=5&offset=${st.page}`)({
      type: PERFORM_SEARCH
    })
  )
}
